<template>
  <div class="content-warp">
    <a-row type="flex" justify="space-between" align="middle" class="company-panle">
      <a-col :span="16">
        <img v-if="userInfo.userLogoUrl" class="company-img" :src="userInfo.userLogoUrl" alt="logo">
        <!-- <img v-else class="company-img" src="../../assets/logo.png" alt="logo"> -->
        <!-- <a-avatar v-else class="default-avatar" icon="user" /> -->
        <img v-else class="default-avatar" src="../../assets/logo.png" alt="logo" />        
        
        <span class="company-name">{{userInfo.rootDeptName}}，{{timeFix(lang)}}</span>
      </a-col>
      <a-col :span="8">
        <p class="clock">{{clockStr}}</p>
        <!-- <div style="text-align: right">
          <img :src="`http://www.weather.com.cn/m2/i/icon_weather/29x20/${weatherImg[0]}`" alt="">
          <span v-if="weatherImg[1]"> ~ </span>
          <img v-if="weatherImg[1]" :src="`http://www.weather.com.cn/m2/i/icon_weather/29x20/${weatherImg[1]}`" alt="">
          
          <span style="margin-left:10px">{{weatherStr}}</span>
        </div> -->
      </a-col>
    </a-row>

    <a-row :gutter="24">
      <a-col :xs="24" :xxl="18" style="padding-bottom:20px">
        <a-card :loading="loading" :title="$t('home.statistic')">
          <!-- 在册用户 -->
          <a-col :xs="8" :style="{ marginBottom: '24px' }">
            <chart-panel 
              :loading="loading" 
              :title="$t('home.registered') +'（' + $t('home.unitMan') + '）'"
              :total="personCount"
              :subContent="personDetail"
            />
          </a-col>
          <!-- 今日人员 -->
          <a-col :xs="8" :style="{ marginBottom: '24px' }">
            <chart-panel 
              :loading="loading" 
              :title="$t('home.todayRegistered') +'（' + $t('home.unitManTime') + '）'"
              :total="personInOutCount"
              :subContent="personInOutDetail"
            />
          </a-col>
          <!-- 今日访客 -->
          <a-col :xs="8" :style="{ marginBottom: '24px' }">
            <chart-panel 
              :loading="loading"
              :title="$t('home.todayVisitor') +'（' + $t('home.unitManTime') + '）'"
              :total="visitorInOutCount"
              :subContent="visitorInOutDetail"
            />
          </a-col>
          <!-- 今日预警 -->
          <a-col :xs="8" :style="{ marginBottom: '24px' }">
            <chart-panel 
              :loading="loading" 
              :title="$t('home.todayWarning') +'（' + $t('home.unitTime') + '）'"
              :total="warningCount"
              :subContent="warningDetail"
            />
          </a-col>
          <!-- 设备 -->
          <a-col :xs="8" :style="{ marginBottom: '24px' }">
            <chart-panel 
              :loading="loading" 
              :title="$t('home.device') +'（' + $t('home.unitSet') + '）'"
              :total="deviceCount"
              :subContent="deviceDetail"
            />
          </a-col>
        </a-card>
      </a-col>
      <a-col :xs="24" :xxl="6">
        <a-card :loading="loading" :title="$t('home.quickAccess')">
          <a-col :xs="8" :xxl="24" style="padding: 2px 10px" @click="handleToDashboard">
            <a-row class="quick-btn" type="flex" justify="space-between" align="middle">
              <div>
                <a-icon type="area-chart" style="fontSize:18px" />
                <span style="margin-left:10px">{{$t('home.dashboards')}}</span>
              </div>
              <a-icon type="right" style="fontSize:24px;color:#bbb" />
            </a-row>
          </a-col>
          <a-col 
            :xs="8" 
            :xxl="24" 
            style="padding: 2px 10px" 
            v-for="item in quickBtn"
            :key="item.name"
            @click="()=>{$router.push({ path: item.path })}"
          >
            <a-row class="quick-btn" type="flex" justify="space-between" align="middle">
              <div>
                <a-icon :type="item.icon" style="fontSize:18px" />
                <span style="margin-left:10px">{{$t(item.name)}}</span>
              </div>
              <a-icon type="right" style="fontSize:24px;color:#bbb" />
            </a-row>
          </a-col>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import moment from 'moment';
import { timeFix } from '@/utils/utils';

import { mapState } from 'vuex';
import ChartPanel from './components/ChartPanel';

import { getUserConfig } from '@/api/userMana';
import { 
  getCountOfDevice,
  getCountOfPerson,
  getCountOfRecogn,
  getCountOfPersonOpenRecogn,
  getCountOfVisitorOpenRecogn,
  getCountWarnning
} from '@/api/statistics';
import { getWeather } from '@/api/common'

export default {
  name: 'homeIndex',
  components: {
    ChartPanel
  },
  data () {
    return {
      loading: true,
      clockStr: '',
      weatherStr: '',
      weatherImg: [],

      personCount: 0, // 在册人员总数
      personDetail: [],

      personInOutCount: 0, // 在册人员进、出门总人次
      personInOutDetail: [],

      visitorInOutCount: 0, // 访客进、出门总人次
      visitorInOutDetail: [],

      warningCount: 0, // 预警总次数
      warningDetail: [],

      deviceCount: 0, // 设备总数
      deviceDetail: [], // 设备总数

      quickBtn: [ // 快速访问按钮
        { name: 'router.orgMana', path: '/org-mana', icon: 'apartment' },
        { name: 'router.personalMana', path: '/personal-mana', icon: 'team' },
        { name: 'router.devicesMana', path: '/devices-mana', icon: 'setting' },
        { name: 'router.identificationRecord', path: '/identification-record', icon: 'security-scan' }
      ],

      recordRefreshTimer: 10 * 1000,
      recordLineRefreshTimer: 60 * 1000,
      otherRefreshTimer: 60 * 1000,

      timeoutFlag: {
        person: null,
        inout: null,
        warning: null,
        device: null
      }
    }
  },
  computed: {
    ...mapState(['userInfo', 'lang'])
  },
  watch: {
    lang: function (lang) {
      this.initChart()
    }
  },
  created () {
    setInterval(this.setClock, 1000)
    // this.getWeather()
    this.getRefreshTimer()

    this.initChart()
  },
  beforeDestroy() {
    this.initTimeoutFlag()
  },
  methods: {
    timeFix,

    // 获取刷新时间配置
    async getRefreshTimer() {
      try {
        const res = await getUserConfig()
        const {
          recordStatisticRefreshIntervalSecond,
          recordRefreshIntervalSecond,
          otherStatisticRefreshIntervalSecond
        } = res.data.collection[0]

        this.recordRefreshTimer = Number(recordStatisticRefreshIntervalSecond) * 1000
        this.recordLineRefreshTimer = Number(recordRefreshIntervalSecond) * 1000
        this.otherRefreshTimer = Number(otherStatisticRefreshIntervalSecond) * 1000
      } catch (error) {}
    },
    
    // 获取天气
    async getWeather() {
      try {
        const res = await getWeather({
          cityName: process.env.NODE_ENV === 'production' ? '' : '成都'
        })
        const { weatherinfo } = JSON.parse(res.data.collection[0])
        this.weatherStr = `${weatherinfo.weather} ${weatherinfo.temp1} ~ ${weatherinfo.temp2}`
        this.weatherImg.push(weatherinfo.img1, weatherinfo.img2)
      } catch (error) {}
    },
    
    // 时钟
    setClock() {
      const fomat = this.lang === 'zh_CN' 
        ? 'YYYY年MM月DD日 HH:mm:ss' : 'MMMM Do YYYY, HH:mm:ss'
      this.clockStr = moment(new Date()).format(fomat)
    },

    initChart() {
      this.loading = true
      this.initTimeoutFlag()

      this.getPersonStatistics()
      this.getPersonVisitorInOut()
      this.getWarningStatistics()
      this.getDeviceStatistics()

      setTimeout(() => { this.loading = !this.loading }, 0)
    },

    initTimeoutFlag() {
      const flags = this.timeoutFlag
      for (let key in flags) {
        const flag = flags[key]
        if (flag) clearTimeout(flag)
        flags[key] = null
      }
      this.timeoutFlag = flags
    },
    refreshTimeoutFlag(type, func, delay) {
      this.timeoutFlag[type] = setTimeout(func, delay)
    },

    // 获取在册人员人数统计
    async getPersonStatistics() {
      try {
        const res = await getCountOfPerson()
        const data = res.data.collection[0]
        this.personCount = data.personAmount
        this.personDetail = [
          { title: this.$t('home.auth'), number: data.expiredPersonAmount },
          { title: this.$t('home.unauth'), number: data.personAmount - data.expiredPersonAmount }
        ]
        this.refreshTimeoutFlag('person', this.getPersonStatistics, this.otherRefreshTimer)
      } catch (error) {
        if (error.response.status !== 401) {
          this.refreshTimeoutFlag('person', this.getPersonStatistics, this.otherRefreshTimer)
        }
      }
    },

    // 人员、访客进出门统计数据
    getPersonVisitorInOut() {
      Promise.all([
        this.getPersonInOutCount(),
        this.getVisitorInOutCount(),
        this.getInOutDataRequest()
      ]).then(res => {
        const personalCount = res[0].data.collection[0]
        const visitorCount = res[1].data.collection[0]
        const inOutRes = res[2].data.collection[0]

        let personIn = 0, personOut = 0, visitorIn = 0, visitorOut = 0;

        inOutRes.items.forEach(item => {          
          if (item.typeCode === 0) { // 人员            
            if (item.typeCode2 === 1) { // 进门
              personIn += item.amount
            } else { // 出门
              personOut += item.amount
            }
          } else { // 预约访客、 临时访客、任何人
            if (item.typeCode2 === 1) { // 进门
              visitorIn += item.amount
            } else { // 出门
              visitorOut += item.amount
            }
          }
        })
        this.personInOutCount = personalCount
        this.personInOutDetail = [
          { title: this.$t('home.enter'), number: personIn },
          { title: this.$t('home.out'), number: personOut }
        ]

        this.visitorInOutCount = visitorCount
        this.visitorInOutDetail = [
          { title: this.$t('home.enter'), number: visitorIn },
          { title: this.$t('home.out'), number: visitorOut }
        ]
        
        this.refreshTimeoutFlag('inout', this.getPersonVisitorInOut, this.recordRefreshTimer)
      }).catch(error => {
        // console.log('-getPersonVisitorInOut-', error)
        if (error.response.status !== 401) {
          this.refreshTimeoutFlag('inout', this.getPersonVisitorInOut, this.recordRefreshTimer)
        }
      })
    },
    // 人员今日进出门总数
    getPersonInOutCount() {
      return getCountOfPersonOpenRecogn({
        start: moment().format('YYYY-MM-DD') + ' 00:00:00',
        end: moment(new Date()).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00'
      })
    },
    // 访客今日进出门总数
    getVisitorInOutCount() {
      return getCountOfVisitorOpenRecogn({
        start: moment().format('YYYY-MM-DD') + ' 00:00:00',
        end: moment(new Date()).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00'
      })
    },
    // 进入、出门分类数据
    getInOutDataRequest() {
      return getCountOfRecogn({
        start: moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00',
        end: moment(new Date()).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00'
      })
    },

    // 预警数据统计
    async getWarningStatistics() {
      try {
        const res = await getCountWarnning({
          start: moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00',
          end: moment(new Date()).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00'
        })
        const data = res.data.collection[0]
        let strangerCount = 0, blackCount = 0;
        data.items.forEach(item => {
          if (item.typeCode === 1) { // 陌生人预警
            strangerCount += item.amount
          } else if (item.typeCode === 2) { // 黑名单预警
            blackCount += item.amount
          }
        })
        this.warningCount = strangerCount + blackCount
        this.warningDetail = [
          { title: this.$t('home.stranger'), number: strangerCount },
          { title: this.$t('home.blacklist'), number: blackCount }
        ]
        this.refreshTimeoutFlag('warning', this.getWarningStatistics, this.otherRefreshTimer)
      } catch (error) {
        // console.log('-getWarningStatistics-', error)
        if (error.response.status !== 401) {
          this.refreshTimeoutFlag('warning', this.getWarningStatistics, this.otherRefreshTimer)
        }
      }
    },
    // 设备数据统计
    async getDeviceStatistics() {
      try {
        const res = await getCountOfDevice()
        const data = res.data.collection[0]
        this.deviceCount = data.deviceAmount
        this.deviceDetail = [
          { title: this.$t('home.online'), number: data.deviceOnlineAmount },
          { title: this.$t('home.outline'), number: data.deviceAmount - data.deviceOnlineAmount }
        ]
        this.refreshTimeoutFlag('device', this.getDeviceStatistics, this.otherRefreshTimer)
      } catch (error) {
        // console.log('-getDeviceStatistics-', error)
        if (error.response.status !== 401) {
          this.refreshTimeoutFlag('device', this.getDeviceStatistics, this.otherRefreshTimer)
        }
      }
    },

    // 快速访问
    handleQuickBtnClick(path) {
      this.router.push({ path: path })
    },
    handleToDashboard() {
      const { href } = this.$router.resolve({ path: '/dashboard' })
      window.open(href, '_blank') 
    }
  }
}
</script>
<style>
  .ant-card-body{
    padding: 10px 24px;
  }
</style>
<style lang="less" scoped>
  *{
    -webkit-touch-callout:none;/*系统默认菜单被禁用*/
    -webkit-user-select:none;/*webkit浏览器*/
    -khtml-user-select:none;/*早期浏览器*/
    -moz-user-select:none;/*火狐*/
    -ms-user-select:none;/*IE10*/
    user-select:none;
  }
  
  .company-panle{
    background-color: #fff;
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-bottom: 24px;
    padding: 12px 30px;

    .default-avatar{
      // width: 70px;
      height: 70px;
      // border-radius: 50%;
      // background-color:#1890ff;
      // font-size: 45px;
      // padding: 10px;
    }

    .company-img{
      width: 70px;
      height: 70px;
      border-radius: 50%;
    }
    .company-name{
      font-size: 24px;
      vertical-align: middle;
      margin-left: 10px;
    }
    .clock{
      font-size: 18px;
      text-align: right;
      margin-bottom: 0;
      line-height: 37px;
    }
  }

  .quick-btn{
    padding: 20px 30px;
    border: 1px solid #e8e8e8;
    border-radius: 5px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .quick-btn:hover{
    box-shadow: 0 2px 8px rgba(0,0,0,.15);
  }
</style>
